import type { MerchantRequest } from "./helpers";

export const REQUEST_STATUS_LABELS: Record<MerchantRequest["status"], string> =
  {
    draft: "Borrador",
    submitted: "En revisión",
    created: "Creado",
    cancelled: "Cancelado",
  };

export const REQUEST_STATUS_COLORS: Record<MerchantRequest["status"], string> =
  {
    draft: "gray",
    submitted: "blue",
    created: "green",
    cancelled: "red",
  };
